import React, { useState, ReactNode } from 'react';
import './UniversalCard.scss';

interface CardData {
  id: string;

  [key: string]: any; // Позволяет передавать любые дополнительные поля
}

interface UniversalCardProps {
  title?: string;
  backgroundColor?: string;
  icon?: ReactNode;
  data?: CardData[];
  renderContent?: (item: CardData, index: number) => ReactNode;
  className?: string;
}

// Моковые данные по умолчанию
const mockCardData: CardData[] = [
  {
    id: '1',
    content: 'Default content 1',
  },
  {
    id: '2',
    content: 'Default content 2',
  },
];

// Иконка по умолчанию (знак доллара)
const defaultIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Контент по умолчанию
const defaultRenderContent = (item: CardData) => (
  <div className="UniversalCard__default-content">
    <div className="UniversalCard__default-text">
      {item.content || `Card ${item.id}`}
    </div>
  </div>
);

const UniversalCard: React.FC<UniversalCardProps> = ({
  title = 'Card Title',
  backgroundColor = '#76C102',
  icon = defaultIcon,
  data = mockCardData,
  renderContent = defaultRenderContent,
  className = '',
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentItem = data[currentIndex];

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : data.length - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev < data.length - 1 ? prev + 1 : 0));
  };

  const goToPage = (index: number) => {
    setCurrentIndex(index);
  };

  const cardStyle = {
    backgroundColor: backgroundColor,
  };

  const iconStyle = {
    color: backgroundColor,
  };

  return (
    <div className={`UniversalCard ${className}`} style={cardStyle}>
      <div className="UniversalCard__header">
        <h3 className="UniversalCard__title">{title}</h3>
        <div className="UniversalCard__icon" style={iconStyle}>
          {icon}
        </div>
      </div>

      <div className="UniversalCard__content">
        {renderContent(currentItem, currentIndex)}
      </div>

      {data.length > 1 && (
        <div className="UniversalCard__navigation">
          <button
            className="UniversalCard__nav-button"
            onClick={goToPrevious}
            aria-label="Previous item"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 12L6 8L10 4"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <div className="UniversalCard__page-numbers">
            {data.map((_, index) => (
              <button
                key={index}
                className={`UniversalCard__page-number ${
                  index === currentIndex
                    ? 'UniversalCard__page-number--active'
                    : ''
                }`}
                onClick={() => goToPage(index)}
                aria-label={`Go to item ${index + 1}`}
              >
                {index + 1}
              </button>
            ))}
          </div>

          <button
            className="UniversalCard__nav-button"
            onClick={goToNext}
            aria-label="Next item"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 4L10 8L6 12"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default UniversalCard;
